import { getProductFeatures } from '../utility/comparator';

export default ngModule => {

    ngModule.directive('serviceFilters', (AonApi, AonConfig, OperatorService) => {
        return {
            restrict: 'E',
            scope: {
                requiresHospital: '=',
                requiresAncillary: '=',
                servicesInColumns: '=',
                primaryServiceNeed: '=',
                // We use the previous fund to access the current policy, to allow
                // looking up the services that policy in order to automatically
                // select those same services
                previousFund: '=',
            },
            template: require('../partials/service-filters.html'),
            link: (scope) => {
                const { service_label_highlight_css } = AonConfig.corporate;
                scope.primaryServiceNeeds = AonConfig.formChoices.primary_service_needs;

                const getServices = which => {
                    const columns = (scope.servicesInColumns || {})[which] || {};
                    return [
                      ...columns.left || [],
                      ...columns.right || [],
                    ];
                };

                const getPrimaryNeed = () => (
                  scope.primaryServiceNeeds.find(_need => _need.code === scope.primaryServiceNeed) ||
                  { hospital_services: [] }
                );

                // Given a service (hospital or ancillary) return a string containing inline styles
                scope.getStyle = (service) => service.highlight ? service_label_highlight_css : '';

                scope.onSelectPrimaryServiceNeed = () => {
                    const need = getPrimaryNeed();
                    getServices('hospital').forEach((hospitalService) => {
                        hospitalService.selected = need.hospital_services.includes(hospitalService.id);
                        hospitalService.changed_from_primary_need = false;
                    });
                    OperatorService.setSelectedTiers(need.hospital_tiers);
                };

                scope.getServiceCSSClass = (service) => ({
                    'checked': service.selected,
                    'changed-from-primary-need': service.changed_from_primary_need,
                });

                // Check if they have a current policy, and if it is one that
                // we know about
                const getCurrentPolicies = () => {
                    const products = [];
                    const previousFund = scope.previousFund || {};
                    if (previousFund.hospital_product && previousFund.hospital_product.id) {
                        products.push(previousFund.hospital_product);
                    }
                    if (previousFund.ancillary_product && previousFund.ancillary_product.id) {
                        products.push(previousFund.ancillary_product);
                    }
                    return products;
                }

                scope.hasCurrentPolicy = () => getCurrentPolicies().length > 0;

                // Using the applicants current policy, get the services that policy covers
                // and select those same services
                scope.selectCurrentProductServices = () => {
                    // Clear all the current selections
                    ['hospital', 'ancillary'].map(
                        which => getServices(which).forEach(service => service.selected = false)
                    );

                    const selectServices = (which, dict) => {
                        Object.keys(dict)
                            .forEach(id => getServices(which).forEach(
                                service => {
                                    if (String(service.id) === id) {
                                        let selected = dict[id] && !dict[id].excluded && !dict[id].unknown;

                                        // Run a check for hospital restrict
                                        // Hospital services "always" has sis_cover
                                        if (which === "hospital") {

                                            // If it is Restricted, don't select this service
                                            if (dict[id].sis_cover === "Restricted") {

                                                selected = false;

                                            }

                                        }

                                        service.selected = selected;
                                    }
                                }));
                    };

                    getCurrentPolicies().forEach(product => {
                        scope.isLoadingCurrentPolicyServices = true;
                        AonApi.fetchPrice({}, product.id).then(response => {
                            const pricePackage = response.data;
                            if (pricePackage) {
                                if (scope.requiresHospital && pricePackage.price.hospital_product) {
                                    selectServices('hospital', getProductFeatures(
                                        pricePackage,
                                        getServices('hospital'),
                                        pricePackage.hospital_product.product_hospital_services
                                    ));
                                }
                                if (scope.requiresAncillary && pricePackage.price.ancillary_product) {
                                    selectServices('ancillary', getProductFeatures(
                                        pricePackage,
                                        getServices('ancillary'),
                                        pricePackage.ancillary_product.product_ancillary_services
                                    ));
                                }
                            }
                        }).finally(() => {
                            scope.isLoadingCurrentPolicyServices = false;
                        });
                    });
                };

                scope.$watch('servicesInColumns', () => {
                    const need = getPrimaryNeed();
                    getServices('hospital').forEach(service => {
                        const isNeedService = need.hospital_services.includes(service.id);
                        service.changed_from_primary_need = (
                          isNeedService && !service.selected ||
                          !isNeedService && service.selected
                        );
                    });
                }, true);
            }
        };
    });
}



// WEBPACK FOOTER //
// ./src/directives/service-filters.js